import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getEnquiries = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.ENQUIRIES);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.ENQUIRIES,
                payload: res.data,
            });
        }
    }
    dispatch(hideLoaderAction());
};

const fetchEnquiryDetails = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.ENQUIRY + id);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.ENQUIRIES_DETAILS,
                payload: res.data,
            });
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

const deleteEnquiry = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.ENQUIRY + id);
    if (res.success) {
        dispatch(getEnquiries());
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { getEnquiries, fetchEnquiryDetails, deleteEnquiry };
